import { useMemo } from "react";
import { useTranslate } from "@refinedev/core";
import { EXPERIENCE_OBJECTIVES } from "data/tones/";
import type { VideoConfigOption } from "../types";

/** Duration choices: API value (seconds) + the locale key naming the option. */
export const DURATION_OPTIONS: { seconds: number; labelKey: string }[] = [
  { seconds: 30, labelKey: "30s" },
  { seconds: 60, labelKey: "1min" },
  { seconds: 120, labelKey: "2min" },
  { seconds: 180, labelKey: "3min" },
  { seconds: 300, labelKey: "5min" },
];

/**
 * Goal / duration option lists shared by every add-on generated
 * through a `VideoGenerationSettings`-shaped schema (Video, HeyGenius).
 */
export const useGenerationFieldOptions = () => {
  const t = useTranslate();

  const goals = useMemo<VideoConfigOption[]>(
    () =>
      Object.keys(EXPERIENCE_OBJECTIVES).map((key) => ({
        value: key,
        label: t(`src.data.experienceObjectives.${key}.name`),
      })),
    [t]
  );

  const durations = useMemo<VideoConfigOption[]>(
    () =>
      DURATION_OPTIONS.map(({ seconds, labelKey }) => ({
        value: seconds,
        label: t(`createExperience.videoConfig.duration.options.${labelKey}`),
      })),
    [t]
  );

  return { goals, durations };
};

export default useGenerationFieldOptions;
